import RemoveCircle from 'assets/icons/RemoveCircle'
import { NavBar } from 'components/NavBar/NavBar'
import { setConfirmModal } from 'features/global/globalSlice'
import {
  clearInventoryFieldsList,
  deleteInvField,
  getInvSettingsFields,
} from 'features/inventory/invSettingsFieldsSlice'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
  Flex,
  GridItem,
  ItemsGrid,
  MainHeadline,
  PageFooter,
  PageWrapper,
} from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { Button } from 'components/ui/Button/Button'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { InventoryFieldsModal } from './InventoryFieldsModal'

export const InventoryFields = () => {
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location }))
  const { fields, totalPages, noFields } = useSelector((store: RootState) => store.invSettingsFields)

  useQueryPagination({ fetchFunctions: [getInvSettingsFields], cleanUpFunctions: [clearInventoryFieldsList], params })

  const removeInvField = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteInvField(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: fields.length < 2,
        },
        word: 'delete field',
      }),
    )
  }

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Inventory Fields...' setParams={setParams} />
      <PageWrapper>
        <Flex between center mb='16' >
          <Flex column gap='0.25rem'>
            <MainHeadline>Inventory Fields</MainHeadline>
            <OtherText grey>Custom field definitions attached to item categories</OtherText>
          </Flex>
          <Button variant='primary' onClick={() => setModal(true)}>
            Add Field
          </Button>
        </Flex>
        {noFields ? <NoItems title='Fields' /> : <ItemsGrid columns={3} mt='1.5rem'>
          {fields &&
            fields.map((item) => {
              return (
                <GridItem key={item.id}>
                  <p onClick={() => navigate('/inventory-fields/' + item.id)}>{item.label}</p>

                  <Flex between center onClick={() => removeInvField(item.id)}>
                    <RemoveCircle />
                  </Flex>
                </GridItem>
              )
            })}
        </ItemsGrid>}


      </PageWrapper>
      {modal &&
        <InventoryFieldsModal closeModal={() => setModal(false)} />
      }
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
